var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0369 12.3645C12.0369 13.1885 11.3717 13.8571 10.5671 13.8571H2.39808C1.57808 13.8571 0.912745 13.1886 0.912745 12.3645V4.15586C0.912745 3.33189 1.57797 2.66333 2.39808 2.66333H7.1324L8.06076 1.73047L2.39813 1.73058C1.06757 1.73058 0 2.81882 0 4.14034V12.3645C0 13.7016 1.08299 14.7743 2.39813 14.7743H10.5672C11.8823 14.7743 12.9653 13.6861 12.9653 12.3645V6.67445L12.0369 7.60731L12.0369 12.3645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2986 2.05617L12.6585 0.408142C12.1169 -0.136047 11.2351 -0.136047 10.6936 0.408142L3.63849 7.51298C3.57665 7.57512 3.53014 7.66849 3.5147 7.76175L2.86489 11.3686C2.83392 11.5241 2.88033 11.6795 2.98868 11.7728C3.09704 11.8817 3.25169 11.9283 3.39092 11.8972L6.98034 11.2442C7.07315 11.2287 7.15053 11.1821 7.22791 11.1198L14.2985 4.01497C14.8398 3.48641 14.8398 2.6002 14.2983 2.05612L14.2986 2.05617ZM10.0439 2.3826L10.8639 3.20657L5.8201 8.2748L5.00011 7.45082L10.0439 2.3826ZM3.88615 10.8711L4.3813 8.1349L6.60924 10.3737L3.88615 10.8711ZM7.28991 9.75173L6.46991 8.92776L11.5137 3.85954L12.3337 4.68351L7.28991 9.75173ZM13.6488 3.36204L12.999 4.015L10.6936 1.72964L11.3435 1.07668C11.5291 0.890151 11.8231 0.890151 11.9933 1.07668L13.6332 2.7246C13.8189 2.89562 13.8188 3.19103 13.6488 3.36204Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.7d363e7cdb5153c32ff2c8e50ef7d860.svg";
export { ForwardRef as ReactComponent };